export default "__VITE_ASSET__DqYZeNWi__"